/**
 * @class msysMessage
 * @description
 * Provides functions to work with Mosy messages:
 * - filtering messages and masking parameters
 * - serialization to text format
 * - deserialization from text format
 * - serialization to binary format
 * - deserialization from binary format
 */

module.exports = {
  ...require('./base.js'),
  ...require('./binary.js'),
  ...require('./filter.js'),
}
